// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"b52a2d12","20":"50c98dd2","50":"140f836e","192":"dac78bcd","206":"916bab5f","334":"f41dcd7b","453":"56c73e7d","472":"3fa7761d","493":"8999fa0b","528":"fcdabdea","559":"49f4f7a0","599":"1accab2b","680":"e8705fe7","951":"c377572e"}[chunkId] + ".chunk.js";
};